export default {"src":"/_next/static/media/basics.679f9ce3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};